<main
  class="contact-us d-flex flex-column justify-content-center align-items-center primary-text"
>
  <div class="contact-heading">
    Get in <strong class="under-img">touch.</strong>
  </div>
  <div class="sub-text text-lg-center">
    We’ve been researching and building enterprise AI since 2016 – it’s our
    passion and we’re happy to talk to you about it. Drop us a line for a
    no-obligation chat.
  </div>
  <button
    (click)="openContactModal()"
    class="talk-btn btn rounded-pill d-flex justify-content-center align-items-center"
  >
    Talk To Us
    <app-qeleo-icon
    class="d-none d-lg-flex"
      [size]="'xxl'"
      iconName="arrow-right-o"
    ></app-qeleo-icon>
    <app-qeleo-icon
    class="d-lg-none"
      [size]="'xl'"
      iconName="arrow-right-o"
    ></app-qeleo-icon>
  </button>
</main>
